// inherits "side": left, right, bottom

import { disableBodyScroll, enableBodyScroll } from '~/js/utilities/dom';

const openDrawers = new Set();

const drawer = (passedSide, passedTitle, contentPadding, forceBackdrop) => ({
  open: false,
  isClosing: false,
  isFirstDrawer: undefined,
  isScrollable: false,

  get sideNormalized() {
    // TODO: when nothing is passed consider auto switching based on screen size
    return this.drawerSide || passedSide || 'right';
  },

  get titleNormalized() {
    return this.drawerTitle ?? passedTitle;
  },

  get hasBackdrop() {
    return this.isFirstDrawer || forceBackdrop;
  },

  init() {
    this.closeOpenDrawers = this.closeOpenDrawers.bind(this);
    this.mutationObserver = new MutationObserver(
      this.handleMutation.bind(this)
    );
    this.mutationObserver.observe(this.$el, {
      attributes: true,
      attributeFilter: ['open'],
    });

    if (contentPadding) {
      this.resizeObserver = new ResizeObserver(this.handleResize.bind(this));
      this.resizeObserver.observe(this.$refs.middle);
    }
  },

  destroy() {
    this.mutationObserver.disconnect();
    this.resizeObserver?.disconnect();

    openDrawers.delete(this);
    if (openDrawers.size === 0) {
      enableBodyScroll();
    }
  },

  close() {
    this.$root.close();
  },

  handleMutation() {
    if (this.isClosing) return;

    const { open: newOpen } = this.$el;

    this.open = newOpen;

    if (newOpen) {
      this.isFirstDrawer = openDrawers.size === 0;
      openDrawers.add(this);
      disableBodyScroll();
    } else {
      openDrawers.delete(this);
      if (openDrawers.size === 0) {
        enableBodyScroll();
      }
    }

    if (!newOpen) {
      this.isClosing = true;

      this.$el.showModal();

      // TODO: use transitionend event instead?
      setTimeout(() => {
        this.$dispatch('drawer-close-complete', { drawer: this });

        this.$el.close();

        Promise.resolve().then(() => {
          this.isClosing = false;
        });
      }, 300);
    }

    this.$dispatch(this.open ? 'drawer-open' : 'drawer-close', {
      drawer: this,
    });
  },

  handleResize() {
    const { middle } = this.$refs;
    if (middle) {
      this.isScrollable = middle.scrollHeight > middle.clientHeight;
    }
  },

  closeOpenDrawers() {
    if (forceBackdrop) {
      this.close();
      return;
    }

    openDrawers.forEach((drawer) => {
      drawer.close();
    });
  },
});

export default drawer;
